'use strict';

import React from 'react';
import { render } from 'react-dom';
import AuthPanel from './AuthPanel.js';
// import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

export default function($) {
	const $footer_container = $('#navbar--footer-container');
	const $footer = $('#navbar--footer');
	const $footer_top = $('#navbar--footer-top');
	
	$footer_container.css({
		position: 'fixed',
		width: 1,
		height: 1,
		left: '-200%',
	});
	
	$footer.addClass('top-0 h-full w-full fixed')
		.css({
			transition: 'opacity .5s ease-out, left .25s ease-out',
			left: '-100%',
			opacity: 0,
			'-webkit-overflow-scrolling': 'touch',
		});
	
	$('#navbar--mobile-menu-button')
		.click(e => {
			e.preventDefault();
			// disableBodyScroll($footer[0], { reserveScrollBarGap: true });
			$footer.css({
				left: 0,
				opacity: 1,
			});
		});
	
	$('#navbar--mobile-close-button')
		.removeClass('hidden')
		.click(e => {
			e.preventDefault();
			// enableBodyScroll($footer[0]);
			$footer.css({
				left: '-100%',
				opacity: 0,
			});
		});
	
	const admin_content = $('#navbar--admin-content').html();
	const csrf = $('meta[name=csrf-token]').attr('content');
	
	window.InterNACHI.session.onGuest(() => {
		render(<AuthPanel loading={ false } user={ null } admin_content={ null } csrf={ csrf } current_url={ window.location.href } />, $footer_top[0]);
	});
	
	window.InterNACHI.session.onLoaded(() => {
		render(<AuthPanel loading={ false } user={ window.logged_in_user } admin_content={ admin_content } csrf={ csrf } current_url={ window.location.href } />, $footer_top[0]);
	});
}
